import {
  Button,
  Card,
  Col,
  Divider,
  Flex,
  Form,
  Input,
  Row,
  Select,
  Table,
  TableProps,
  Tag,
} from 'antd';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import BranchSelect from '../../../lib/BranchSelect';
import { notifyError, notifySuccess } from '../../../store/utils';
import { API } from '../../../api';

const BranchDeliveryManCreate = () => {
  const { memberNo } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [branch, setBranch] = useState<any>();
  const [targetBagHorooList, setTargetBagHorooList] = useState<any[]>([]);
  const [address, setAddress] = useState([]);
  const [loading1, setLoading1] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [selected, setSelected] = useState<any[]>([]);
  const [pageSize, setPageSize] = useState<any>(50);
  const fetchDeliveryMember = useCallback(async () => {
    try {
      const {
        result: { data },
      } = await API.get({ apiVersion: 'api' })(`/member/branch/delivery-man/edit/${memberNo}`);
      const deliveryMan = data?.deliveryMan;
      form.setFieldsValue({
        branchNo: deliveryMan?.roles?.[0]?.courierBranch?.no,
        email: deliveryMan?.email,
        fname: deliveryMan?.firstName,
        phone1: deliveryMan?.phone,
      });
      setAddress(deliveryMan?.addresses || []);
      setBranch(deliveryMan?.roles?.[0]?.courierBranch);
      const list = (data?.targetAddress || []).map((item: any) => {
        return {
          ...item,
          key: item.no,
        };
      });
      setTargetBagHorooList(list);
    } catch (error: any) {
      notifyError(error.message);
    }
  }, [memberNo]);

  const onFinish = useCallback(
    async (values: any) => {
      try {
        setLoading(true);
        if (memberNo) {
          await API.put({ apiVersion: 'api' })(
            `/member/branch/delivery-man/staff/update/${memberNo}`,
            values
          );
          notifySuccess('Амжилттай хадгаллаа');
          fetchDeliveryMember();
        } else {
          const {
            result: { data },
          } = await API.post({ apiVersion: 'api' })(
            `/member/branch/delivery-man/staff/create`,
            values
          );
          notifySuccess('Амжилттай хадгаллаа');
          navigate(`/settings/branch/delivery/update/${data.no}`);
        }
      } catch (error: any) {
        notifyError(error.message);
      } finally {
        setLoading(false);
      }
    },
    [memberNo]
  );

  useEffect(() => {
    if (memberNo) {
      fetchDeliveryMember();
    }
  }, [memberNo]);
  const selectedRowKeys = useMemo(() => {
    return selected.map((itm) => itm.no);
  }, [selected]);

  const rowSelection: TableProps<any>['rowSelection'] = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
      setSelected(selectedRows);
    },
    selectedRowKeys,
    getCheckboxProps: (record: any) => ({
      disabled: record.name === 'Disabled User',
      name: record.name,
    }),
  };

  const columns = useMemo(() => {
    return [
      {
        title: 'Зип код',
        dataIndex: 'zipcode',
      },
      {
        title: 'Аймаг хот',
        dataIndex: 'province',
        render: (val: any) => val?.name,
      },
      {
        title: 'Сум дүүрэг',
        dataIndex: 'district',
        render: (val: any) => val?.name,
      },
      {
        title: 'Баг хороо',
        dataIndex: 'name',
      },
      {
        title: 'Салбар',
        dataIndex: 'branchName',
      },
      {
        title: 'Харъялах эсэх',
        render: (val: any, row: any) => {
          const check = address.find((add: any) => add.no == row.no);
          return (
            <span>
              {check ? (
                <Tag
                  color={
                    row.deliveryManNo != null && row.deliveryManNo !== memberNo
                      ? '#fa8c16'
                      : '#87d068'
                  }
                >
                  Сонгогдсон
                </Tag>
              ) : (
                <Tag>Сонгогдоогүй</Tag>
              )}
            </span>
          );
        },
      },
    ];
  }, [address]);

  const createAddress = useCallback(async () => {
    try {
      setLoading1(true);
      const payload = {
        action: 'CREATE',
        streetNos: selected.map((itm: any) => itm.no),
      };
      await API.post({ apiVersion: 'api' })(
        `/member/branch/delivery-man/address/${memberNo}`,
        payload
      );
      notifySuccess('Амжилттай хадгалаа');
      setSelected([]);
      fetchDeliveryMember();
    } catch (error: any) {
      notifyError(error.message);
    } finally {
      setLoading1(false);
    }
  }, [selected, memberNo]);

  const deleteAddress = useCallback(async () => {
    try {
      setLoading2(true);
      const payload = {
        action: 'DELETE',
        streetNos: selected.map((itm: any) => itm.no),
      };
      await API.post({ apiVersion: 'api' })(
        `/member/branch/delivery-man/address/${memberNo}`,
        payload
      );
      notifySuccess('Амжилттай хадгалаа');
      setSelected([]);
      fetchDeliveryMember();
    } catch (error: any) {
      notifyError(error.message);
    } finally {
      setLoading2(false);
    }
  }, []);

  return (
    <Card title={`Хүргэгч нэмэх`}>
      <Row>
        <Col span={12} offset={6}>
          <Form
            form={form}
            onFinish={onFinish}
            layout="vertical"
            initialValues={{
              role: 'BRANCH_STAFF',
            }}
          >
            <Form.Item
              name="branchNo"
              label="Салбар"
              rules={[{ required: true, message: 'Салбар сонгоно уу' }]}
            >
              <BranchSelect disabled={!!memberNo} allowClear showSearch />
            </Form.Item>
            <Form.Item
              name="email"
              label="Нэвтрэх нэр"
              rules={[{ required: true, message: 'Нэвтрэх нэр оруулна уу' }]}
            >
              <Input disabled={!!memberNo} placeholder="Нэвтрэх нэр" />
            </Form.Item>
            <Form.Item
              name="password"
              label="Нууц үг"
              rules={[{ required: memberNo ? false : true, message: 'Нууц үг оруулна уу' }]}
            >
              <Input placeholder="Нууц үг" />
            </Form.Item>
            <Form.Item
              name="fname"
              label="Нэр"
              rules={[{ required: true, message: 'Нэр оруулна уу' }]}
            >
              <Input placeholder="Нэр" />
            </Form.Item>
            <Form.Item
              name="phone1"
              label="Утас"
              rules={[{ required: true, message: 'Утас оруулна уу' }]}
            >
              <Input placeholder="Утас" />
            </Form.Item>
            <Form.Item>
              <Flex justify="end" gap={24}>
                <Button onClick={() => navigate(-1)} htmlType="button">
                  Буцах
                </Button>
                <Button loading={loading} type="primary" htmlType="submit">
                  Хадгалах
                </Button>
              </Flex>
            </Form.Item>
          </Form>
        </Col>
      </Row>
      <Row>
        <Col span={18} offset={3}>
          <Divider />
        </Col>
      </Row>
      <Row style={{ marginBottom: 24 }}>
        <Col span={18} offset={3}>
          <Flex gap={24}>
            <Button disabled={!selected.length} loading={loading1} onClick={() => createAddress()}>
              Идвэхжүүлэх
            </Button>
            <Button disabled={!selected.length} loading={loading2} onClick={() => deleteAddress()}>
              Идвэхгүй болгох
            </Button>
          </Flex>
        </Col>
      </Row>
      <Row>
        <Col span={18} offset={3}>
          <Table
            rowKey={(record: any) => record.no}
            rowSelection={rowSelection}
            columns={columns}
            size="small"
            pagination={{
              pageSize: pageSize,
              onShowSizeChange: (_, size) => setPageSize(size),
              showSizeChanger: true,
            }}
            dataSource={targetBagHorooList}
          />
        </Col>
      </Row>
    </Card>
  );
};

export default BranchDeliveryManCreate;
